import React from 'react';
import { MailIcon, InstagramIcon, GlobeIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-ink py-14 text-cream" data-id="element-105" data-mp="3ggaqtvj9sd5g">
      <div className="mx-auto max-w-3xl px-5 text-center" data-id="element-106" data-mp="3gh3rqfvjs8fo">
        <p className="font-display text-xl font-bold text-rose-soft" data-id="element-107" data-mp="32p5lqdx4usnq">💅 Estética Digital Pro™</p>
        <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-cream/70" data-id="element-108" data-mp="36q92r3qx2uqj">
          El sistema N°1 para dueñas de centros de estética, estéticas médicas y cosmetólogas de
          Argentina que quieren convertir su Instagram en una máquina de turnos sin depender de un
          community manager.
        </p>
        <p className="mx-auto mt-4 max-w-xl text-sm italic text-cream/60" data-id="element-109" data-mp="3le2l2w7e0bct">
          Porque tener una estética exitosa no debería costarte todos los domingos del año.
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-cream/80" data-id="element-110" data-mp="29ydxc2mb78ay">
          <a href="mailto:soporte@creativodigital.shop" className="inline-flex items-center gap-2 transition-colors hover:text-rose-soft" data-id="element-111" data-mp="2ezl3xycpu1g1">
            <MailIcon className="h-4 w-4" data-id="element-112" data-mp="3gbimorwfpo1t" /> soporte@creativodigital.shop
          </a>
          <a href="https://instagram.com/creativodigital" className="inline-flex items-center gap-2 transition-colors hover:text-rose-soft" data-id="element-113" data-mp="3v7zw3dl2cslq">
            <InstagramIcon className="h-4 w-4" data-id="element-114" data-mp="82qrjqil5pso" /> @creativodigital
          </a>
          <a href="https://www.creativodigital.shop" className="inline-flex items-center gap-2 transition-colors hover:text-rose-soft" data-id="element-115" data-mp="80nrednpyga8">
            <GlobeIcon className="h-4 w-4" data-id="element-116" data-mp="hsad53xonxr8" /> www.creativodigital.shop
          </a>
        </div>

        <div className="mt-8 border-t border-white/10 pt-6 text-xs text-cream/50" data-id="element-117" data-mp="cu8uul8302gt">
          <p data-id="element-118" data-mp="qujilfe3h0xr">
            © Creativo Digital™ 2026 — Todos los derechos reservados. Prohibida la reproducción y
            redistribución sin autorización expresa.
          </p>
          <p className="mt-4 font-display text-base italic text-rose-soft" data-id="element-119" data-mp="tvmnzb2xs4iq">
            💅 "El próximo domingo puede ser diferente."
          </p>
        </div>
      </div>
    </footer>;
}